import { ReactNode } from 'react';
import { jukTheme } from './theme';
import { GetBrandTheme } from '@leadflow/shared/theme/GetBrandTheme';

const ThemeProviderWrapper = ({ children }: { children: ReactNode }) => {
  return <GetBrandTheme brandTheme={jukTheme}>{children}</GetBrandTheme>;
};

export default ThemeProviderWrapper;
